module.exports = __webpack_public_path__ + "img/amba.4b8422f3.png";